var GAMEPADS = {
    XBOX_ONE: {
        D_LEFT: 14,
        D_RIGHT: 15,
        D_UP: 12,
        D_DOWN: 13,
        STICK_L_X: 0,
        STICK_L_Y: 1,
        STICK_R_X: 2,
        STICK_R_Y: 3,
    },
};
export default GAMEPADS;
//# sourceMappingURL=gamepads.js.map